<template>
    <div class="famous-pedia-read-web-left">
        <div class="famous-pedia-read-web-base-info">
            <div class="famous-form-rw-title">
                <h1 class="famous-form-rw-name">{{curPediaBaziInfo.f_name}}</h1>
                <div class="famous-form-rw-sub">
                    <span class="famous-form-rw-subtitle">创建者</span><span>{{curPediaBaziEditInfo.creatorName}}</span>
                    <span class="famous-form-rw-subtitle">浏览次数</span><span>{{curPediaBaziEditInfo.pvTime}}次</span>
                    <span class="famous-form-rw-edit" @click="clickEditHistory">编辑历史</span>
                </div>
            </div>
            <!-- 2. 简介部分 -->
            <div id="famousInfo" class="famous-form-rw-info">
                <p class="famous-form-rw-info-content">{{curPediaPipanInfo.base}}</p>
            </div>
            <div id="famousShare" class="famous-form-button-box">
                <qrcode class="famous-form-button-img" id='qrImg' tag="img" :options="{size: 140, padding: 0}" :value="CONFIG.getWechatShareUrl(curPediaBaziInfo.id)" ></qrcode>
                <div class="famous-form-button-sub-note">扫一扫  在手机上保存</div>
                <button class="famout-form-btn-red" @click="clickReport">智能测算</button>
                <button class="famout-form-btn-green" @click="clickDownload">下载天时子平八字</button>
                <!-- 弹框 -->
                <div v-if="curWebFamousPediaMenu == 7" class="web-my-famous-pedia-pop-left">
                    <span class="web-my-famous-pedia-triangle " v-bind:class="'triangle-' + curWebFamousPediaMenu"></span>
                    <div class="famous-code-box dsp-flex">
                        <div class="famous-code-item">
                            <div class="famous-code-qrcode" ref="qrCodeIOS">
                                <div class="famous-code-icon"><i class="iconfont icon-ios"></i></div>
                            </div>
                            <div class="famous-code-text">ios下载</div>
                        </div>
                        <div class="famous-code-item">
                            <div class="famous-code-qrcode" ref="qrCodeAND">
                                <div class="famous-code-icon"><i class="iconfont icon-android"></i></div>
                            </div>
                            <div class="famous-code-text">Android下载</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { CONFIG } from '../../modules/config'
export default {
    name: 'FamousPediaLeftWeb',
    computed: {
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        },
        curPediaPipanInfo() {
            return this.$store.state.famouspedia.curPediaPipanInfo;
        },
        curPediaBaziEditInfo() {
            return this.$store.state.famouspedia.curPediaBaziEditInfo
        },
        curWebFamousPediaMenu() {
            return this.$store.state.weblogin.curWebFamousPediaMenu;
        },
    },
    data() {
        return {
            CONFIG: CONFIG
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            // 添加窗口改变大小监听事件
            window.onresize = function() {
                setTimeout(() => {
                    me.initDom();
                }, 20);
            }
        }, 20);
    },
    methods: {
        initDom() {
            var topDiv = document.getElementsByClassName('famous-pedia-rwp-topbar')[0],
                bottomDiv = document.getElementsByClassName('famous-pedia-rwp-bottombar')[0],
                titleDiv = document.getElementsByClassName('famous-form-rw-title')[0],
                infoDiv = document.getElementById('famousInfo'),
                shareDiv = document.getElementById('famousShare');
            var height = innerHeight-40;
                height = topDiv ? height-topDiv.clientHeight : height;
                height = bottomDiv ? height-bottomDiv.clientHeight : height;
                height = titleDiv ? height-titleDiv.clientHeight : height;
                height = shareDiv ? height-shareDiv.clientHeight : height;
            if(infoDiv) {
                infoDiv.style.height = height + 'px';
            }
        },
        initQrCode() {
            var qrcode1 = new QRCode(this.$refs.qrCodeIOS, {
                text: CONFIG.ios_durl,
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
            var qrcode2 = new QRCode(this.$refs.qrCodeAND, {
                text: CONFIG.android_durl,
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
        },
        clickEditHistory() {
            this.$store.dispatch('famouspedia/getBaikeLog');
            // 打开编辑历史弹框
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            this.$store.state.weblogin.curWebFamousPediaMenu = 4;
            // var me = this;
            // setTimeout(() => {
            //     me.$store.state.weblogin.showWebFamousPediaPop = false;
            // }, 5000);
        },
        clickReport() {
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/collate');
        },
        clickDownload() {
            if(this.$store.state.weblogin.curWebFamousPediaMenu == 7) {
                return;
            }
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            this.$store.state.weblogin.curWebFamousPediaMenu = 7;
            var me = this;
            setTimeout(() => {
                me.initQrCode();
            }, 10);
            // window.open(CONFIG.download_url);
        }
    }
}
</script>